import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

export const ProfileDeleteButton = () => {
    const navigate = useNavigate();

    const handleDeleteProfile = () => {
        navigate('delete');
    };

    return (
        <Button
            onClick={handleDeleteProfile}
            style={{ paddingLeft: 0 }}
            type={'link'}
            danger
        >
            Удалить аккаунт
        </Button>
    );
};
